import React from "react";
import { PropTypes } from "prop-types";
import { connectWithLifecycle } from "react-lifecycle-component";
import { push } from "react-router-redux";
import {
  saveOrder,
  showAllOrders,
  setSearchText
} from "../../redux/modules/ordersDuck";
import { getShowingAllOrders, getSearchText } from "../../redux/selectors";
import OrderListItem from "../presentational/OrderListItem";
import { List } from "material-ui/List";
import { getOrderStatus } from "../../redux/selectors";
import IconButton from "material-ui/IconButton";
import Deliver from "material-ui/svg-icons/action/check-circle";
import Return from "material-ui/svg-icons/navigation/cancel";
import TextField from "material-ui/TextField";
import Checkbox from "material-ui/Checkbox";
import Visibility from "material-ui/svg-icons/action/visibility";
import VisibilityOff from "material-ui/svg-icons/action/visibility-off";
import HighlightOff from "material-ui/svg-icons/action/highlight-off";

const mapStateToProps = state => {
  return {
    showAllOrders: getShowingAllOrders(state),
    searchText: getSearchText(state)
  };
};

const mapDispatchToProps = dispatch => ({
  handleEditOrder: order => {
    dispatch(push("/order/" + order.get("id")));
  },

  handleDeliverOrder: order => {
    const action = order.get("delivered")
      ? saveOrder(order.set("delivered", false))
      : getOrderStatus(order.toJS()) === "DONE"
        ? saveOrder(order.set("delivered", true))
        : { type: "NOOP", order };

    dispatch(action);
  },
  handleShowAllOrders: (event, isInputChecked) => {
    dispatch(showAllOrders(isInputChecked));
  },
  handleSetSearchText: text => {
    dispatch(setSearchText(text));
  }
});

export const OrderList = props => {
  const {
    orders,
    handleEditOrder,
    handleDeliverOrder,
    handleShowAllOrders,
    handleSetSearchText,
    searchText,
    showAllOrders
  } = props;

  //The following is a case-insensitive accent_folding text search
  //Reference: https://alistapart.com/article/accent-folding-for-auto-complete
  const accentMap = {
    á: "a",
    é: "e",
    í: "i",
    ó: "o",
    ú: "u"
  };
  const accent_fold = s => {
    if (!s) {
      return "";
    }
    var ret = "";
    for (var i = 0; i < s.length; i++) {
      ret += accentMap[s.charAt(i)] || s.charAt(i);
    }
    return ret;
  };

  const textToSearch = accent_fold(searchText.toLowerCase());
  const filteredOrders = orders
    .filter(o => (showAllOrders ? true : !o.get("delivered")))
    .filter(
      o =>
        accent_fold(o.get("customerName"))
          .toLowerCase()
          .includes(textToSearch) ||
        (o.get("team") &&
          accent_fold(o.getIn(["team", "name"]))
            .toLowerCase()
            .includes(textToSearch))
    );

  const orderListItems = filteredOrders
    ? filteredOrders.map((o, i) => {
        const rightIcon = (
          <IconButton onClick={() => handleDeliverOrder(o)}>
            {o.get("delivered")
              ? <Return />
              : getOrderStatus(o.toJS()) === "DONE" ? <Deliver /> : ""}
          </IconButton>
        );
        return (
          <OrderListItem
            key={i}
            order={o.toJS()}
            onClick={handleEditOrder}
            rightIcon={rightIcon}
          />
        );
      })
    : "";
  const listItemStyle = {
    float: "left",
    height: "1em",
    width: "1em",
    margin: "0 5px 0 0"
  };

  return (
    <div>
      <Checkbox
        checked={showAllOrders}
        onCheck={handleShowAllOrders}
        checkedIcon={<Visibility />}
        uncheckedIcon={<VisibilityOff />}
        style={{
          marginLeft: 4,
          marginBottom: 16,
          width: "auto",
          display: "inline-block"
        }}
        iconStyle={{ paddingTop: 7 }}
      />
      <TextField
        hintText={showAllOrders ? "Buscar en todos" : "Buscar en pendientes"}
        value={searchText || ""}
        onChange={(event, value) => handleSetSearchText(value)}
      />
      {searchText
        ? <IconButton
            tooltip="Borrar búsqueda"
            onClick={() => handleSetSearchText("")}
            style={{ width: 28, height: 28, padding: 4, top: 6 }}
            iconStyle={{
              width: 20,
              height: 20,
              color: "grey",
              iconHoverColor: "black"
            }}
          >
            <HighlightOff />
          </IconButton>
        : ""}

      <List>
        {orderListItems}
      </List>
      <p>Leyenda:</p>
      <ul>
        <li style={{ listStyle: "none" }}>
          <span style={{ ...listItemStyle, backgroundColor: "red" }} />
          Pedido sin pagar
        </li>
        <li style={{ listStyle: "none" }}>
          <span style={{ ...listItemStyle, backgroundColor: "lightgrey" }} />
          Pedido sin empezar a producir
        </li>
        <li style={{ listStyle: "none" }}>
          <span style={{ ...listItemStyle, backgroundColor: "orange" }} />
          Pedido en proceso de producción
        </li>
        <li style={{ listStyle: "none" }}>
          <span
            style={{ ...listItemStyle, backgroundColor: "lightgreen" }}
          />Pedido completamente producido
        </li>
        <li style={{ listStyle: "none" }}>
          <span
            style={{ ...listItemStyle, backgroundColor: "mediumpurple" }}
          />Pedido entregado
        </li>
      </ul>
    </div>
  );
};

OrderList.propTypes = {
  currentOrder: PropTypes.object,
  handleEditOrder: PropTypes.func.isRequired,
  handleDeliverOrder: PropTypes.func.isRequired
};
const OrderListComponent = connectWithLifecycle(
  mapStateToProps,
  mapDispatchToProps
)(OrderList);

export default OrderListComponent;



// WEBPACK FOOTER //
// ./src/components/container/OrderList.js